import { render, staticRenderFns } from "./SchoolSemesterDetail.vue?vue&type=template&id=73a4ec90&scoped=true"
import script from "./SchoolSemesterDetail.vue?vue&type=script&lang=js"
export * from "./SchoolSemesterDetail.vue?vue&type=script&lang=js"
import style0 from "./SchoolSemesterDetail.vue?vue&type=style&index=0&id=73a4ec90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4ec90",
  null
  
)

export default component.exports